function openSizeChart() {
  document.getElementById('size-chart-modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeSizeChart(e) {
  if (!e || e.target.id === 'size-chart-modal') {
    document.getElementById('size-chart-modal').classList.remove('open');
    document.body.style.overflow = '';
    closeHowDrawer();
  }
}

function openHowDrawer() {
  document.getElementById('sc-how-drawer').classList.add('open');
}

function closeHowDrawer() {
  document.getElementById('sc-how-drawer').classList.remove('open');
}

function switchUnit(unit) {
  document.getElementById('sc-table-cm').classList.toggle('hidden', unit !== 'cm');
  document.getElementById('sc-table-inch').classList.toggle('hidden', unit !== 'inch');
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    if (document.getElementById('sc-how-drawer').classList.contains('open')) {
      closeHowDrawer();
    } else {
      closeSizeChart();
    }
  }
});